export default __webpack_public_path__ + "static/media/thumb-1.8f7f251d.png";